exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  CHARTJS */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!F:/SVNNew/Web/Phoenix Website/Website_Admin/node_modules/postcss-loader?{"ident":"postcss"}!F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/modules/vendors/chartjs/chartjs.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/chartjs/chartjs.css
// module chunks = styles